/**
 * A person's age in whole years.
 *
 * Not a formatter, so it does not belong in `@privacy-bee/format`: this is a fact about a
 * person that the vault and the add-child form both gate on (a child's plan,
 * an adult's consent), and the number is compared rather than printed.
 *
 * Whole years as of today in the viewer's zone, which is what "how old are
 * they" means to the person filling the form in front of them. The birthday is
 * reached on the day itself: the month-and-day comparison below is what stops
 * a date-of-birth in the back half of the year reading a year too high.
 */
export function calculateAge(dateOfBirth: string | Date): number | null {
    if (!dateOfBirth) return null;

    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}
